const INDEXABLE_ROUTE_KEYS = new Set([
  "home",
  "watch",
  "series",
  "video",
  "profile",
  "business",
  "capsule",
  "raffle",
]);

const TICKET_ROUTE_REGEX = /^\/raffle\/[^/]+\/ticket\/[^/]+\/?$/i;

export const ROUTE_MATCHERS = [
  { key: "home", regex: /^\/$/i },
  { key: "watch", regex: /^\/watch\/?$/i },
  { key: "series", regex: /^\/series\/([^/]+)\/?$/i, params: ["idOrSlug"] },
  { key: "video", regex: /^\/video\/([^/]+)\/?$/i, params: ["idOrSlug"] },
  { key: "profile", regex: /^\/u\/([^/]+)\/?$/i, params: ["handle"] },
  { key: "business", regex: /^\/business\/([^/]+)\/?$/i, params: ["idOrSlug"] },
  { key: "capsule", regex: /^\/capsule\/([^/]+)\/?$/i, params: ["idOrSlug"] },
  { key: "raffle", regex: /^\/raffle\/([^/]+)\/?$/i, params: ["idOrSlug"] },
];

function normalizePath(pathname = "/") {
  const path = String(pathname || "/").split("?")[0].trim();
  return path || "/";
}

export function isNoindexOnlyPath(pathname) {
  const path = normalizePath(pathname).toLowerCase();

  if (path.startsWith("/admin")) return true;
  if (path.startsWith("/signin") || path.startsWith("/signup") || path.startsWith("/phone-otp")) return true;
  if (path.startsWith("/messages")) return true;
  if (path.startsWith("/profile/settings") || path.startsWith("/profile/edit")) return true;
  if (path.startsWith("/settings")) return true;
  if (path.startsWith("/membership")) return true;
  if (path.startsWith("/points-ledger")) return true;
  if (path.startsWith("/timecapsule")) return true;
  if (path === "/me" || path === "/u/me") return true;
  if (path.startsWith("/profile/connections")) return true;
  if (TICKET_ROUTE_REGEX.test(path)) return true;

  return false;
}

export function parseRoute(pathname = "/") {
  const path = normalizePath(pathname);

  for (const matcher of ROUTE_MATCHERS) {
    const match = path.match(matcher.regex);
    if (!match) continue;

    const params = {};
    (matcher.params || []).forEach((name, index) => {
      params[name] = decodeURIComponent(match[index + 1] || "");
    });

    return { routeKey: matcher.key, params, path };
  }

  return { routeKey: "unknown", params: {}, path };
}

export function isIndexableRoute(routeKey) {
  return INDEXABLE_ROUTE_KEYS.has(routeKey);
}

